import { getValue } from ".";

export const getAnticipo = (pagos = []) =>
  (pagos || [])
    .filter((pago) => pago.fecha_cancelacion === null)
    .filter(
      (pago) =>
        String(pago.comentario).toLowerCase().includes("anticipo") ||
        getValue(pago, "anticipo", "boolean")
    )
    .reduce((a, b) => parseFloat(a) + parseFloat(b.monto), 0.0);

export const getTotalPagos = (pagos = []) =>
  (pagos || [])
    .filter((pago) => pago.fecha_cancelacion === null)
    .reduce((a, b) => parseFloat(a) + parseFloat(b.monto), 0.0);

export const getTotalPagosAmortizados = (pagos = []) =>
  (pagos || [])
    .filter((pago) => pago.fecha_cancelacion === null)
    .filter((pago) => pago.monto_amortizado)
    .reduce((a, b) => parseFloat(a) + parseFloat(b.monto_amortizado), 0.0);

export const getTotalPagosCuenta = (pagos = []) =>
  (pagos || [])
    .filter((pago) => pago.fecha_cancelacion === null)
    .filter(
      (pago) =>
        pago.idEstimacion === null && !getValue(pago, "anticipo", "boolean")
    )
    .reduce((a, b) => parseFloat(a) + parseFloat(b.monto), 0.0);
